export const GET_PRODUCTS = 'GET_PRODUCTS';
export const PRODUCT_TYPE_PRODUCT = 'product';
export const PRODUCT_TYPE_SERVICE = 'service';
